module.exports = __webpack_public_path__ + "img/500_IdentityTheft.32865fab.png";